// export function convertCurrencyToFloat(value: string) {
//     if(value != "") {
//         var splited = value.split("R$");
//         return parseFloat(splited[splited.length > 1 ? 1 : 0].trim().replace(".", "").replace(",", "."));
//     } else {
//         return 0;
//     }
// };

export const convertCurrencyToFloat = (currencyString: string): number => {
    if(!currencyString) return 0;
        return parseFloat(currencyString.replace(/[^\d,]/g, '').replace(",", "."));
};

export const formatCurrencyToBRL = (value: number | string): string => {
    const num = typeof value === 'string' ?
        parseFloat(value.replace(/[^\d,]/g, '').replace(',', '.')) || 0 :
        value;

        return num.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2
        });
};